import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router';

import { useTypedSearchParams } from '@/hook';
import {
  DeveloperBoard,
  VButton,
  VFlex,
  VSelect,
  VTabTrigger,
  VTabTriggerContainer,
} from '@/package';
import type { ModelingListSearchParams } from '@/type';

const ModelingDetailPageHeader = () => {
  const { t } = useTranslation();
  const { get, set, flush } = useTypedSearchParams<ModelingListSearchParams>();
  const navigate = useNavigate();
  const { modelingId } = useParams();

  return (
    <VFlex className="w-full py-4" justify="between">
      <VFlex gap={1} items="center">
        <VTabTriggerContainer>
          <VTabTrigger value="1"> List </VTabTrigger>
          <VTabTrigger value="2"> Performance </VTabTrigger>
        </VTabTriggerContainer>
      </VFlex>

      <VFlex gap={1} items="center">
        <div className="w-[104px]">
          <VSelect
            value={get('modelingLimit') as string}
            onChange={e => {
              set('modelingLimit', e._target.value);
              flush();
            }}
            itemList={[
              { label: '20ea', value: '20' },
              { label: '10ea', value: '10' },
            ]}
            fluid
          />
        </div>
        <VButton
          size="lg"
          onClick={() => {
            navigate(`/modeling/${modelingId}/training`);
          }}
        >
          <DeveloperBoard />
          {t('modeling.versionTrainingButtonText.cyzicene')}
        </VButton>
      </VFlex>
    </VFlex>
  );
};

export default ModelingDetailPageHeader;
